var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638501344443,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6382,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.664034 847.425652h988.673928a17.664034 17.664034 0 0 0 17.664035-17.664034v-635.521239a17.664034 17.664034 0 0 0-17.664035-17.664035H17.664034A17.664034 17.664034 0 0 0 0 194.176379v635.585239c0 9.792019 7.936015 17.664034 17.664034 17.664034z",
    fill: "#C8414B",
    "p-id": 6383
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 317.82462h1024.001997v388.352757H0z",
    fill: "#FFD250",
    "p-id": 6384
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432.576844 512.000998l14.976029-67.392131a9.920019 9.920019 0 0 0-9.728019-12.032023h-10.560021c-6.336012 0-11.072022 5.888011-9.664019 12.032023L432.576844 512.000998z",
    fill: "#C8414B",
    "p-id": 6385
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M414.912809 476.67293h35.264069v150.080292h-35.264069z",
    fill: "#F5F5F5",
    "p-id": 6386
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M406.080792 459.008895h52.928103v17.664035h-52.928103z",
    fill: "#FAB446",
    "p-id": 6387
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M370.752723 512.000998h88.320172v17.664035h-88.320172V512.000998z m88.320172 70.592138l-52.992103-17.600034v-17.664035l52.928103 17.664035v17.600034zM167.680327 512.000998l14.976029-67.392131a9.920019 9.920019 0 0 0-9.728019-12.032023h-10.56002c-6.336012 0-11.072022 5.888011-9.664019 12.032023L167.680327 512.000998z",
    fill: "#C8414B",
    "p-id": 6388
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.504448 459.008895a17.664034 17.664034 0 0 0-17.664035 17.664035v114.752223c0 21.504042 20.032039 61.824121 88.320172 61.824121 68.224133 0 88.256172-40.320079 88.256172-61.824121V476.67293a17.664034 17.664034 0 0 0-17.664034-17.664035H229.504448z",
    fill: "#F5F5F5",
    "p-id": 6389
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M300.160585 547.329067H211.840413V476.67293c0-9.728019 7.936015-17.664034 17.664035-17.664035H300.160585v88.320172z m0 0h88.256172v44.160086a44.160086 44.160086 0 1 1-88.320172 0v-44.160086z",
    fill: "#C8414B",
    "p-id": 6390
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.840413 547.329067h88.320172v44.160086a44.160086 44.160086 0 1 1-88.320172 0v-44.160086z",
    fill: "#FAB446",
    "p-id": 6391
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M293.504572 626.561222V547.329067h-21.312041v87.360171a58.368114 58.368114 0 0 0 21.312041-8.128016z m-42.624083 8.128016V547.329067h-21.376041V626.561222c6.272012 3.840007 13.440026 6.784013 21.376041 8.128016z",
    fill: "#C8414B",
    "p-id": 6392
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M229.504448 512.000998h52.992103v17.664035h-52.992103z",
    fill: "#FFB441",
    "p-id": 6393
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M229.504448 476.67293h52.992103v17.664034h-52.992103z",
    fill: "#FAB446",
    "p-id": 6394
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M238.336465 487.16895h35.328069v32.000062h-35.328069z",
    fill: "#FAB446",
    "p-id": 6395
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.080293 476.67293h35.328069v150.080292h-35.328069z",
    fill: "#F5F5F5",
    "p-id": 6396
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.248275 617.921205h64.000125v17.664034h-64.000125v-17.664034z m0-158.91231h64.000125v17.664035h-64.000125v-17.664035z",
    fill: "#FAB446",
    "p-id": 6397
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.416258 635.585239h70.592138v17.664035H132.480258z",
    fill: "#5064AA",
    "p-id": 6398
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M414.912809 617.921205h52.928103v17.664034h-52.928103z",
    fill: "#FAB446",
    "p-id": 6399
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M397.248775 635.585239H467.840912v17.664035H397.248775z",
    fill: "#5064AA",
    "p-id": 6400
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M247.168482 441.408861h105.920207v17.600034H247.168482z",
    fill: "#FAB446",
    "p-id": 6401
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M291.328568 388.416757h17.664035v52.992104h-17.664035z",
    fill: "#FFB441",
    "p-id": 6402
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M288.000562 425.920831a32.000062 32.000062 0 1 1 0.064-64.000125 32.000062 32.000062 0 0 1-0.064 64.000125z m0-42.688084a10.688021 10.688021 0 1 0 0 21.376042 10.688021 10.688021 0 0 0 0-21.376042z",
    fill: "#F5F5F5",
    "p-id": 6403
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M323.32863 425.920831a32.000062 32.000062 0 1 1 0-64.000125 32.000062 32.000062 0 0 1 0 64.000125z m0-42.688084a10.688021 10.688021 0 1 0 0 21.376042 10.688021 10.688021 0 0 0 0-21.376042z",
    fill: "#F5F5F5",
    "p-id": 6404
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M353.088689 443.584865c-14.592028 0-26.496052-14.336028-26.496052-32.000062s11.904023-32.000062 26.496052-32.000063c14.592028 0 26.496052 14.336028 26.496051 32.000063s-11.904023 32.000062-26.496051 32.000062z m0-42.688083c-4.864009 0-8.832017 4.800009-8.832018 10.688021 0 5.888011 3.968008 10.688021 8.832018 10.68802 4.864009 0 8.832017-4.800009 8.832017-10.68802 0-5.888011-3.968008-10.688021-8.832017-10.688021z m-105.920207 42.688083c-14.592028 0-26.496052-14.336028-26.496052-32.000062s11.904023-32.000062 26.496052-32.000063c14.592028 0 26.496052 14.336028 26.496052 32.000063s-11.904023 32.000062-26.496052 32.000062z m0-42.688083c-4.864009 0-8.832017 4.800009-8.832017 10.688021 0 5.888011 3.968008 10.688021 8.832017 10.68802 4.864009 0 8.832017-4.800009 8.832017-10.68802 0-5.888011-3.968008-10.688021-8.832017-10.688021z",
    fill: "#F5F5F5",
    "p-id": 6405
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M360.448703 586.241143v10.752021a10.688021 10.688021 0 0 1-21.312042 0V586.241143h21.312042m21.312041-21.312041h-64.000124v32.000062a32.000062 32.000062 0 0 0 64.000124 0v-32.000062z",
    fill: "#FAB446",
    "p-id": 6406
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M344.320671 529.665033A17.664034 17.664034 0 0 1 326.528637 512.000998v-17.664034a17.664034 17.664034 0 0 1 35.328069 0V512.000998a17.664034 17.664034 0 0 1-17.664035 17.664035z",
    fill: "#FFA0D2",
    "p-id": 6407
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M273.664534 547.329067a26.496052 26.496052 0 1 0 52.928103 0 26.496052 26.496052 0 0 0-52.928103 0z",
    fill: "#5064AA",
    "p-id": 6408
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M291.328568 353.088689h17.664035v52.992103h-17.664035z",
    fill: "#FAB446",
    "p-id": 6409
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M247.168482 441.408861l-17.664034-17.664035 10.36802-10.36802c33.280065-33.280065 87.23217-33.280065 120.576235 0l10.30402 10.36802-17.664034 17.664035H247.168482z",
    fill: "#C8414B",
    "p-id": 6410
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M291.328568 446.912871c0 17.664034 3.904008 32.000062 8.832017 32.000063 4.864009 0 8.832017-14.336028 8.832018-32.000063s-3.968008-32.000062-8.832018-32.000062c-4.92801 0-8.832017 14.336028-8.832017 32.000062z m-35.328069 0c0 17.664034 3.968008 32.000062 8.832017 32.000063 4.864009 0 8.832017-14.336028 8.832018-32.000063s-3.968008-32.000062-8.832018-32.000062c-4.864009 0-8.832017 14.336028-8.832017 32.000062z m70.592138 0c0 17.664034 3.968008 32.000062 8.832017 32.000063 4.92801 0 8.832017-14.336028 8.832017-32.000063s-3.904008-32.000062-8.832017-32.000062c-4.864009 0-8.832017 14.336028-8.832017 32.000062z",
    fill: "#FFD250",
    "p-id": 6411
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.248275 512.000998h88.320173v17.664035h-88.320173V512.000998z m0 70.592138l52.928104-17.600034v-17.664035l-52.928104 17.664035v17.600034z",
    fill: "#C8414B",
    "p-id": 6412
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.66f8250e.svg";
export { ForwardRef as ReactComponent };